<template>
  <div class="row">
    <div class="box row" v-bind:style="{ backgroundImage: backgroundUrl }">
      <div class="full-page p-40">
        <div class="full-page-container">
          <div class="row">
            <div class="col text-center">
              <lottie
                :options="defaultOptions"
                v-on:animCreated="handleAnimation"
              ></lottie>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <h2 class="m-t-40">{{ $t("sessionExpired.title") }}</h2>
              <p>{{ $t("sessionExpired.text") }}</p>
            </div>
            <div class="col-sm-12 m-t-40 text-center">
              <button
                v-if="merchantDetails.returnUrl"
                class="btn btn-cta"
                @click="backToMerchant()"
              >
                {{ $t("btnBackToShop") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="row page">
      <div class="col-sm-12 text-center">
        {{ $t("protectedBy") }}
        <a href="https://www.cm.com" target="_blank">CM.com</a>
      </div>
    </footer>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../assets/animation/pending.json";
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "paymentSessionExpired",
  components: {
    Lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
    };
  },
  computed: {
    ...paymentNS.mapGetters(["merchantDetails", "backgroundUrl", "cssUrl"]),
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    backToMerchant() {
      window.location.href = this.merchantDetails.returnUrl;
    },
  },
};
</script>
